"use strict";
/**
 * Note: Most of the code in this file was pulled from the ga.js
 * file. Some typing was added, some refactoring was done, but
 * generally it was left as-is.
 */
Object.defineProperty(exports, "__esModule", { value: true });
const hashString = (input) => {
    let b = 1;
    let c;
    // tslint:disable: no-bitwise
    if (input) {
        for (b = 0,
            c = input.length - 1; 0 <= c; c--) {
            let d = input.charCodeAt(c);
            b = (b << 6 & 268435455) + d + (d << 14);
            d = b & 266338304;
            b = 0 !== d ? b ^ d >> 21 : b;
        }
    }
    // tslint:enable: no-bitwise
    return b;
};
exports.default = hashString;
